module.exports = __webpack_public_path__ + "static/media/token3.56acae8c.png";